import React from "react";
import { motion } from "framer-motion";
import {
  Layout,
  Sparkles,
  Cpu,
  Users,
  ArrowUpRight,
} from "lucide-react";
import Reveal from "../motion/Reveal";
import { services } from "../../data/content";

const iconMap = { Layout, Sparkles, Cpu, Users };

export default function Services() {
  return (
    <section
      id="leistungen"
      className="relative bg-white py-32 lg:py-44"
      data-testid="services-section"
    >
      <div className="max-w-[90rem] mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-16 lg:mb-24">
          <div className="lg:col-span-7">
            <Reveal>
              <p className="eyebrow">Leistungen</p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-4 font-display font-medium text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-balance">
                Vier Disziplinen.
                <br />
                <span className="text-brand-muted">Ein gemeinsames Ziel:</span>{" "}
                Sichtbarkeit, die wirkt.
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-4 lg:col-start-9">
            <Reveal delay={0.1}>
              <p className="text-brand-muted text-lg leading-relaxed">
                Wir kombinieren, was zusammen gehört: Design, Content,
                Technologie und Menschen. So entstehen digitale Auftritte, die
                nicht nur schön sind — sondern liefern.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {services.map((s, i) => {
            const Icon = iconMap[s.icon];
            return (
              <Reveal key={s.id} delay={i * 0.08}>
                <motion.article
                  whileHover={{ y: -6 }}
                  transition={{ type: "spring", stiffness: 200, damping: 20 }}
                  className="group relative overflow-hidden card-elevated p-8 lg:p-10 h-full"
                  data-testid={`service-card-${s.id}`}
                >
                  <div className="flex items-start justify-between">
                    <div className="inline-flex items-center gap-2 text-brand-muted text-xs tracking-widest uppercase font-semibold">
                      <span>{s.kicker}</span>
                      <span className="h-px w-8 bg-brand-border" />
                    </div>
                    <div className="h-12 w-12 rounded-2xl bg-brand-light border border-brand-border grid place-items-center transition-all duration-500 group-hover:bg-brand-accent group-hover:border-brand-accent group-hover:shadow-[0_0_0_6px_rgba(14,165,233,0.15)] group-hover:scale-105">
                      <Icon className="h-5 w-5 text-brand-primary group-hover:text-white transition-colors duration-500" />
                    </div>
                  </div>

                  <h3 className="mt-8 font-display font-medium text-3xl lg:text-4xl tracking-tight leading-[1.05]">
                    {s.title}
                  </h3>
                  <p className="mt-4 text-brand-primary/80 text-lg leading-relaxed">
                    {s.lead}
                  </p>
                  <p className="mt-3 text-brand-muted leading-relaxed">
                    {s.body}
                  </p>

                  <ul className="mt-6 flex flex-wrap gap-2">
                    {s.tags.map((t) => (
                      <li
                        key={t}
                        className="text-xs font-medium px-3 py-1.5 rounded-full bg-brand-light border border-brand-border text-brand-primary/80"
                      >
                        {t}
                      </li>
                    ))}
                  </ul>

                  <div className="mt-8 flex items-center justify-between">
                    <a
                      href="#kontakt"
                      className="inline-flex items-center gap-1.5 text-sm font-medium text-brand-accent hover:text-brand-accentHover transition-colors"
                      data-testid={`service-cta-${s.id}`}
                    >
                      Mehr erfahren
                      <ArrowUpRight className="h-4 w-4" />
                    </a>
                    <div className="text-brand-muted/40 text-xs uppercase tracking-widest">
                      Nr. {s.kicker}
                    </div>
                  </div>
                </motion.article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
